module.exports = __webpack_public_path__ + "static/media/24UHCHR13.b73eaf45.jpg";